import { render, staticRenderFns } from "./adminClientOffersBoard.vue?vue&type=template&id=705a818b&scoped=true&"
import script from "./adminClientOffersBoard.vue?vue&type=script&lang=js&"
export * from "./adminClientOffersBoard.vue?vue&type=script&lang=js&"
import style0 from "./adminClientOffersBoard.vue?vue&type=style&index=0&id=705a818b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a818b",
  null
  
)

export default component.exports